import React from 'react'

import { Icon, CubeOutline, Close, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string, number, oneOfType } from 'prop-types'

import { clearGenerationResultForRun } from 'Pods/Shared/GenerationStatus/actions'
import usePreviewUrlRefresh from 'Pods/Shared/GenerationStatus/usePreviewUrlRefresh'

const PREVIEW_ICON_SIZE = { width: '24', height: '24' }
const CLOSE_ICON_SIZE = { width: '16', height: '16' }

const SUCCEEDED = 'succeeded'

// One finished-run result row: success links to the generated model with its
// preview; error links back to the studio with a placeholder glyph (a failed run
// has no shareable model). Opening a row clears that run's result while the other
// stacked rows stay (per product: each persists until opened). The trailing X
// clears the same run without navigating, so a result the user does not want to
// open no longer has to be opened just to make it go away.
function GenerationResult({ result, labels }) {
  const isSuccess = result.status === SUCCEEDED
  const href = isSuccess ? result.pathname : labels.errorHref
  const label = isSuccess ? labels.readyTitle : labels.errorTitle
  const previewUrl = isSuccess ? result.previewUrl : undefined
  const handlePreviewError = usePreviewUrlRefresh({ runId: result.runId, previewUrl })

  const handleClick = () => clearGenerationResultForRun(result.runId)

  return (
    <div className="unified-nav__dropdown-result-row">
      <a
        className={classnames(
          'unified-nav__dropdown-result',
          isSuccess ? 'unified-nav__dropdown-result--success' : 'unified-nav__dropdown-result--error'
        )}
        href={href}
        data-track-label="Create with AI"
        data-track-text={isSuccess ? 'Generation ready' : 'Generation issue'}
        onClick={handleClick}
      >
        <span className="unified-nav__dropdown-result-preview">
          {previewUrl ? (
            <img
              className="unified-nav__dropdown-result-image"
              src={previewUrl}
              alt=""
              onError={handlePreviewError}
            />
          ) : (
            <Icon notSpaced color="dark" size={PREVIEW_ICON_SIZE} svgComponent={CubeOutline} />
          )}
        </span>
        <span className="unified-nav__dropdown-result-label cgt-body-base-semibold">{label}</span>
      </a>
      <button
        type="button"
        className="unified-nav__dropdown-result-close"
        onClick={handleClick}
        aria-label={labels.dismiss}
      >
        <Icon notSpaced color="dark" size={CLOSE_ICON_SIZE} svgComponent={Close} />
      </button>
    </div>
  )
}

GenerationResult.propTypes = {
  result: shape({
    runId: oneOfType([number, string]),
    status: string,
    pathname: string,
    previewUrl: string,
  }).isRequired,
  labels: shape({
    readyTitle: string,
    errorTitle: string,
    errorHref: string,
    dismiss: string,
  }).isRequired,
}

export default GenerationResult
